import { chatCompletionResponseSchema } from '@/schemas/chatCompletionResponse'
import { buildAetherBlocks } from './aetherProjectBlocks.js'
import { assistantMetaFromChatResponse, normalizeBlocksFromChatResponse } from './assistantMeta.js'

export function normalizeChatCompletionData(data) {
  const parsed = chatCompletionResponseSchema.safeParse(data)
  if (!parsed.success) return { ok: false, code: 'INVALID_RESPONSE', message: parsed.error.message }

  const d = parsed.data
  const textRaw = d.message || d.text || d.reply || d.choices?.[0]?.message?.content || d.choices?.[0]?.text
  const text = textRaw != null ? String(textRaw).trim() : ''
  const projectBlocks = d.project ? buildAetherBlocks(text, new Map(), d.project) : null
  const blocks = projectBlocks || normalizeBlocksFromChatResponse(d)

  if (!text && !blocks?.length) {
    return { ok: false, code: 'INVALID_RESPONSE', message: 'No assistant text or blocks.' }
  }

  return { ok: true, text, ...(blocks?.length ? { blocks } : {}), ...assistantMetaFromChatResponse(d) }
}
